import classNames from 'classnames';
import * as React from 'react';

// Utils
// Constants
// Actions
// Models
import { TechnicalStopModel } from '@src/shared/src/models';
// Interfaces
// Components
import TechnicalStops from '@pod/trips/components/TechnicalStops';
// Styles
import './styles/BookingInfoItem.scss';

type Props = React.PropsWithChildren & {
  icon?: JSX.Element;
  depName: string;
  depAt?: string;
  title?: string;
  arrName?: string;
  arrAt?: string;
  depTime?: string;
  arrTime?: string;
  changeover?: boolean;
  technicalStops?: TechnicalStopModel[];
};

export const BookingInfoItem: React.FC<Props> = (props) => {
  const {
    title,
    icon,
    depName,
    arrName,
    depAt,
    arrAt,
    changeover,
    children,
    depTime,
    arrTime,
    technicalStops,
  } = props;

  return (
    <div className="lp-booking-info-item">
      {title && <div className="lp-booking-info-item-title">{title}</div>}
      <div className="lp-booking-info-item-inner">
        <div className="lp-booking-info-item-details">
          <div className="lp-booking-info-item-segment">
            {depTime && <div className="lp-booking-info-item-time">{depTime}</div>}

            <div
              className={classNames('lp-booking-info-item-route', {
                'is--dep': arrName,
                'no--icon': !icon,
              })}>
              <div className="lp-booking-info-item-icon">{icon}</div>
              <div className="lp-booking-info-item-location">{depName}</div>
              <TechnicalStops technicalStops={technicalStops} />
              <div className="lp-booking-info-item-date">{depAt}</div>
            </div>
          </div>

          {arrName && (
            <div className="lp-booking-info-item-segment">
              {arrTime && <div className="lp-booking-info-item-time">{arrTime}</div>}
              <div
                className={classNames('lp-booking-info-item-route is--arr', {
                  'is--changeover': changeover,
                })}>
                <div className="lp-booking-info-item-location">{arrName}</div>
                {arrAt && <div className="lp-booking-info-item-date">{arrAt}</div>}
              </div>
            </div>
          )}
        </div>
        {children && <div className="lp-booking-info-item-additional">{children}</div>}
      </div>
    </div>
  );
};
